import { Button, ButtonProps } from "antd";
import { ReactNode } from "react";
import IMG from "../../assets/images/congratulations.svg";
import { CustomModalProps } from "../../types";
import CustomModal from "../ui/CustomModal";

type ConfirmModalProps = {
  text: string;
  iconImage?: string;
    children?: ReactNode;
  buttonProps?: React.ForwardRefExoticComponent<
    ButtonProps & React.RefAttributes<HTMLButtonElement | HTMLAnchorElement>
  >;
} & CustomModalProps;

export default function CongratulationsModal({
  text,
  handleClose,
  closable = false,
  iconImage = IMG,
  buttonProps,
  maskClosable = false,
    children,
  ...rest
}: ConfirmModalProps) {
  return (
    <CustomModal
      width={400}
      className={`confirm-modal`}
      handleClose={handleClose}
      closable={closable}
      title={undefined}
      footer={null}
      maskClosable={maskClosable}
      {...rest}
    >
      <div className="py-2">
        <div className="flex justify-center">
          <img className="h-16 object-contain" src={iconImage} alt="" />
        </div>
        <p className="text-center text-black text-base font-normal my-4">
          {text}
        </p>
        <div>
          {children}
        </div>
        <div className="flex justify-center">
          <Button
            type="text"
            className="!bg-[#F2F5FF] min-w-24 rounded-full !text-primary"
            size="small"
            onClick={() => handleClose && handleClose(true)}
            {...buttonProps}
          >
            Ok
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
